export default "__VITE_ASSET__$SDA2mno__"